export default __webpack_public_path__ + "static/media/gasag_l3.3795dadc.png";